import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import FileSaver from 'file-saver';
import { ApiUrls } from 'src/app/services/ApiUrls';
// import { grievanceServerUrl } from '../../grievenceServerUrl';
import * as XLSX from 'xlsx';
@Injectable({
  providedIn: 'root'
})
export class ReportService {

  constructor(public httpClient: HttpClient) { }
  //load board rest
  async loadBoard() {

    const url = "loadBoards";
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.loadBoard, {})
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }
  //

  //load grievance rest with board id
  async loadGrievance(depId: any,bordId:any) {
    const data = { 'depId': depId,'bdId':bordId };

    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.loadGrievanceByDpidV2, data)
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }
  //



  //load mhada user grievance rest
  async loadGrievances() {
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.loadGrievanceForReport, {})
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }
  //


  selectDetailsForReport(data) {
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.loadForReport, data)
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }

  //load departments type rest
  async loadDepartments(boardId: any) {
    const data = { 'bdId': boardId, };
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.loadDepartment, data)
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }
  //
}
